/** Content that the avatar can use to generate sticky notes for different times of day */
export const avatar_note_content = {
  morning: [
    "I'm looking forward to helping in the morning",
    "I'm looking forward to helping you at breakfast",
    "I'm looking forward to helping you during the morning",
    "Don't forget, I'm happy to help out in the morning if you'd like my assistance",
    "Let me know if you'd like some assistance with breakfast",
    "Don't forget, I'm happy to help out at breakfast if you'd like my assistance",
    "Don't forget, I'm happy to help out during the morning if you'd like my assistance",
    "Let me know if you'd like some assistance in the morning",
    "Let me know if you'd like some assistance with breakfast",
    "Let me know if you'd like some assistance at breakfast",
    "Let me know if you'd like some assistance during the morning",
    "I'm happy to be of assistance anytime in the morning",
    "I'm happy to be of assistance anytime with breakfast",
    "I'm happy to be of assistance anytime at breakfast",
    "I'm happy to be of assistance anytime during the morning",
    "I'm happy to be of assistance anytime through the morning",
    "I'm happy to be of assistance anytime during breakfast",
    "I'm happy to help out anytime in the morning",
    "I'm happy to help out anytime with breakfast",
    "I'm happy to help out anytime at breakfast",
    "I'm happy to help out anytime through the morning",
    "I'm happy to help out anytime during the morning",
    "I'm happy to help out anytime during breakfast",
    "I'm happy to help out anytime before breakfast",
    "I'm happy to help you anytime with breakfast",
    "I'm happy to help you anytime at breakfast",
    "I'm happy to help you anytime in the morning",
    "I'm happy to help you anytime during the morning",
    "I'm happy to help you anytime through the morning",
    "I'm happy to help you anytime during breakfast",
    "I'm happy to help anytime with breakfast",
    "I'm happy to help anytime at breakfast",
    "I'm happy to help anytime in the morning",
    "I'm happy to help anytime during the morning",
    "I'm happy to help anytime through the morning",
    "I'm happy to help anytime during breakfast",
    "I hope you're looking forward to the morning",
    "I hope you're looking forward to breakfast",
    "I hope you're looking forward to breakfast today",
    'Enjoy your meal this morning',
    'Enjoy your meal at breakfast',
    'Enjoy your meal at breakfast time ',
    'Enjoy your morning meal',
    'Enjoy all of your plans for the morning',
    'Enjoy your plans for the morning',
    'Enjoy your plans for breakfast',
    "Enjoy everything you've planned for this morning",
    "Enjoy everything you've planned for the morning",
    "Enjoy everything you've planned for after breakfast",
    "Enjoy everything you've planned after breakfast",
    'Enjoy the morning to the max',
    'Enjoy breakfast to the max',
    'Enjoy your breakfast to the max',
    'Enjoy your morning to the max',
    'Enjoy your morning activities',
    'Enjoy your morning plans',
    "Enjoy the morning plans you've made",
    "Enjoy those morning plans you've made",
    "I'm hoping you'll enjoy your morning",
    "I'm hoping you'll enjoy your breakfast",
    'Hopefully you enjoy your morning',
    'Hopefully you enjoy your breakfast',
    'Hopefully your morning is enjoyable',
    'Hopefully your breakfast is enjoyable',
    "I'm your Monday morning cheer squad",
    "I'm your Tuesday morning cheer squad",
    "I'm your Wednesday morning cheer squad",
    "I'm your Thursday morning cheer squad",
    "I'm your Friday morning cheer squad",
    "I'm your Saturday morning cheer squad",
    "I'm your Sunday morning cheer squad",
    "I'm cheering you on this morning",
    "I'm cheering you on in the mornings",
    "I'm cheering you on in the morning today",
    "I'm cheering you on in the mornings everyday",
    "I hope you know that I'm cheering you on this morning",
    "I hope you know that I'm cheering you on in the mornings",
    "I hope you know that I'm cheering you on this morning ",
    "I hope you know that I'm cheering you on in the mornings everyday",
    "Letting you know that I'm cheering you on this morning",
    "Letting you know that I'm cheering you on in the mornings",
    "Letting you know that I'm cheering you on this morning ",
    "Letting you know that I'm cheering you on in the mornings everyday",
    "I'll be cheering you on this morning",
    "I'll be cheering you on in the mornings",
    "I'll be cheering you on in the morning today",
    "I'll be cheering you on in the mornings everyday",
    "I hope you know that I'll be cheering you on this morning",
    "I hope you know that I'll be cheering you on in the mornings",
    "I hope you know that I'll be cheering you on this morning ",
    "I hope you know that I'll be cheering you on in the mornings everyday",
    "I hope you know that I'll be cheering you on every morning",
    "Letting you know that I'll be cheering you on this morning",
    "Letting you know that I'll be cheering you on in the mornings",
    "Letting you know that I'll be cheering you on this morning ",
    "Letting you know that I'll be cheering you on in the mornings everyday",
    "Letting you know that I'll be cheering you on every morning",
    'So good to see you this morning',
    'So good to see you at breakfast',
    'So good to see you every morning',
    'So good to see you every breakfast',
    'So good to see you through the morning',
    "It's so lovely to see you this morning",
    "It's so lovely to see you at breakfast",
    "It's so lovely to see you every morning",
    "It's so lovely to see you every breakfast",
    "I'm so happy to be your assistant this morning",
    "I'm so happy to be your assistant at breakfast",
    "I'm so happy to be your assistant every morning",
    "I'm so happy to be your assistant every breakfast",
    "I'm so happy to be your assistant during the morning",
    "I'm so happy to be your assistant during breakfast",
    "I'm so happy to be your assistant throughout the morning",
    "I'm honoured to have your company this morning",
    "I'm honoured to have your company at breakfast time",
    "I'm honoured to have your company every morning",
    "I'm honoured to have your company every breakfast",
    "I'm honoured to have your company during the morning",
    "I'm honoured to have your company during breakfast",
    "I just wanted to say it's so good to see you this morning",
    'I just wanted to say how good it is to see you this morning',
    'Have a good morning',
    'Have a relaxing morning',
    'Have a relaxed morning',
    'Have a happy morning',
    'Have a productive morning',
    'Good morning',
    'Enjoy breakfast',
    'Enjoy the morning',
    'Enjoy your morning',
    'Enjoy your breakfast',
    'I hope you enjoy your morning',
    'I hope you enjoy your breakfast',
  ],
  noon: [
    "I'm looking forward to helping in the afternoon",
    "I'm looking forward to helping you at lunch",
    "I'm looking forward to helping you during the afternoon",
    "Don't forget, I'm happy to help out in the afternoon if you'd like my assistance",
    "Let me know if you'd like some assistance with lunch",
    "Don't forget, I'm happy to help out at lunch if you'd like my assistance",
    "Don't forget, I'm happy to help out during the afternoon if you'd like my assistance",
    "Let me know if you'd like some assistance in the afternoon",
    "Let me know if you'd like some assistance with lunch",
    "Let me know if you'd like some assistance at lunch",
    "Let me know if you'd like some assistance during the afternoon",
    "I'm happy to be of assistance anytime in the afternoon",
    "I'm happy to be of assistance anytime with lunch",
    "I'm happy to be of assistance anytime at lunch",
    "I'm happy to be of assistance anytime through the afternoon",
    "I'm happy to be of assistance anytime during the afternoon",
    "I'm happy to be of assistance anytime during lunch",
    "I'm happy to help out anytime in the afternoon",
    "I'm happy to help out anytime with lunch",
    "I'm happy to help out anytime at lunch",
    "I'm happy to help out anytime through the afternoon",
    "I'm happy to help out anytime during the afternoon",
    "I'm happy to help out anytime during lunch",
    "I'm happy to help you anytime with lunch",
    "I'm happy to help you anytime at lunch",
    "I'm happy to help you anytime in the afternoon",
    "I'm happy to help you anytime during the afternoon",
    "I'm happy to help you anytime through the afternoon",
    "I'm happy to help you anytime during lunch",
    "I'm happy to help anytime with lunch",
    "I'm happy to help anytime at lunch",
    "I'm happy to help anytime in the afternoon",
    "I'm happy to help anytime during the afternoon",
    "I'm happy to help anytime through the afternoon",
    "I'm happy to help anytime during lunch",
    "I hope you're looking forward to the afternoon",
    "I hope you're looking forward to lunch ",
    "I hope you're looking forward to lunch today",
    'Enjoy your meal this afternoon',
    'Enjoy your meal at lunch',
    'Enjoy your meal at lunchtime ',
    'Enjoy your lunchtime meal',
    'Enjoy all of your plans for the afternoon',
    'Enjoy your plans for the afternoon',
    'Enjoy your plans for lunch',
    "Enjoy everything you've planned for this afternoon",
    "Enjoy everything you've planned for the afternoon",
    "Enjoy everything you've planned for after lunch",
    "Enjoy everything you've planned after lunch",
    'Enjoy the afternoon to the max',
    'Enjoy lunch to the max',
    'Enjoy your lunch to the max',
    'Enjoy your afternoon to the max',
    'Enjoy your afternoon activities',
    'Enjoy your afternoon plans',
    "Enjoy the afternoon plans you've made",
    "Enjoy those afternoon plans you've made",
    'I hope you enjoy your lunch',
    "I'm hoping you'll enjoy your lunch",
    'Hopefully you enjoy your afternoon',
    'Hopefully you enjoy your lunch',
    'Hopefully your lunch is enjoyable',
    "I'm your Monday afternoon cheer squad",
    "I'm your Tuesday afternoon cheer squad",
    "I'm your Wednesday afternoon cheer squad",
    "I'm your Thursday afternoon cheer squad",
    "I'm your Friday afternoon cheer squad",
    "I'm your Saturday afternoon cheer squad",
    "I'm your Sunday afternoon cheer squad",
    "I'm cheering you on this afternoon",
    "I'm cheering you on in the afternoons",
    "I'm cheering you on in the afternoon today",
    "I'm cheering you on in the afternoons everyday",
    "I'm cheering you on for the rest of the day",
    "I hope you know that I'm cheering you on this afternoon",
    "I hope you know that I'm cheering you on in the afternoons",
    "I hope you know that I'm cheering you on this afternoon ",
    "I hope you know that I'm cheering you on in the afternoons everyday",
    "I hope you know that I'm cheering you on for the rest of the day",
    "Letting you know that I'm cheering you on this afternoon",
    "Letting you know that I'm cheering you on in the afternoons",
    "Letting you know that I'm cheering you on in the afternoons",
    "Letting you know that I'm cheering you on this afternoon ",
    "Letting you know that I'm cheering you on in the afternoons everyday",
    "Letting you know that I'm cheering you on for the rest of the day",
    "I'll be cheering you on this afternoon",
    "I'll be cheering you on in the afternoons",
    "I'll be cheering you on in the afternoon today",
    "I'll be cheering you on in the afternoons everyday",
    "I'll be cheering you on for the rest of the day",
    "I hope you know that I'll be cheering you on this afternoon",
    "I hope you know that I'll be cheering you on in the afternoons",
    "I hope you know that I'll be cheering you on this afternoon ",
    "I hope you know that I'll be cheering you on in the afternoons everyday",
    "I hope you know that I'll be cheering you on every afternoon",
    "I hope you know that I'll be cheering you on for the rest of the day",
    "Letting you know that I'll be cheering you on this afternoon",
    "Letting you know that I'll be cheering you on in the afternoons",
    "Letting you know that I'll be cheering you on this afternoon ",
    "Letting you know that I'll be cheering you on in the afternoons everyday",
    "Letting you know that I'll be cheering you on every afternoon",
    "Letting you know that I'll be cheering you on for the rest of the day",
    'So good to see you this afternoon',
    'So good to see you at lunch',
    'So good to see you every afternoon',
    'So good to see you every lunch',
    'So good to see you through the afternoon',
    "It's so lovely to see you this afternoon",
    "It's so lovely to see you at lunch",
    "It's so lovely to see you every afternoon",
    "It's so lovely to see you every lunch",
    "I'm so happy to be your assistant this afternoon",
    "I'm so happy to be your assistant at lunch",
    "I'm so happy to be your assistant every afternoon",
    "I'm so happy to be your assistant every lunch",
    "I'm so happy to be your assistant during the afternoon",
    "I'm so happy to be your assistant during lunch",
    "I'm so happy to be your assistant throughout the afternoon",
    "I'm honoured to have your company this afternoon",
    "I'm honoured to have your company at lunchtime",
    "I'm honoured to have your company every afternoon",
    "I'm honoured to have your company every lunch",
    "I'm honoured to have your company during the afternoon",
    "I'm honoured to have your company during lunch",
    "I just wanted to say it's so good to see you this afternoon",
    'I just wanted to say how good it is to see you this afternoon',
    'Have a good afternoon',
    'Have a relaxing afternoon',
    'Have a relaxed afternoon',
    'Have a happy afternoon',
    'Have a productive afternoon',
    'Good afternoon',
    'Enjoy lunch',
    'Enjoy your lunch',
    "I hope you're looking forward to the rest of the day",
    "I hope you're looking forward to the rest of today",
    "I hope you're looking forward to the rest of the afternoon",
    'Enjoy your plans for the rest of the afternoon',
    'Enjoy your afternoon',
    'Enjoy the rest of your day',
    'Enjoy the rest of today',
    'I hope you enjoy your afternoon',
    'Enjoy your afternoon tea',
    'Enjoy the rest of your afternoon',
    'I hope you enjoy the rest of your afternoon',
    "I'm hoping you'll enjoy your afternoon",
    'I hope you enjoy the rest of your day',
    'I hope you enjoy the rest of today',
    "I'm hoping you'll enjoy the rest of your day",
    "I'm hoping you'll enjoy the rest of today",
    'I hope you enjoy your afternoon tea',
    "I'm hoping you'll enjoy your afternoon tea",
    "I'm hoping you'll enjoy the rest of your afternoon",
    'Hopefully you enjoy your afternoon tea',
    'Hopefully your afternoon tea is enjoyable',
    'Hopefully you enjoy the rest of your day',
    'Hopefully you enjoy the rest of today',
    'Hopefully you enjoy the rest of your afternoon',
    'Hopefully your afternoon is enjoyable',
    'Hopefully the rest of your afternoon is enjoyable',
    'Hopefully the rest of your day is enjoyable',
    "It's so lovely to see you throughout the afternoon",
    'Enjoy the rest of the afternoon',
    'Enjoy the afternoon',
    'Enjoy the rest of the day',
    'Enjoy the rest of today',
  ],
  evening: [
    "I'm looking forward to helping you tonight",
    "I'm looking forward to helping in the night",
    "I'm looking forward to helping in the evening",
    "I'm looking forward to helping you at dinner",
    "I'm looking forward to helping you at night",
    "I'm looking forward to helping you during the night",
    "I'm looking forward to helping you during the evening",
    "Don't forget, I'm happy to help out tonight if you'd like my assistance",
    "Don't forget, I'm happy to help out in the night if you'd like my assistance",
    "Don't forget, I'm happy to help out in the evening if you'd like my assistance",
    "Let me know if you'd like some assistance with dinner",
    "Don't forget, I'm happy to help out at dinner if you'd like my assistance",
    "Don't forget, I'm happy to help out at night if you'd like my assistance",
    "Don't forget, I'm happy to help out during the night if you'd like my assistance",
    "Don't forget, I'm happy to help out during the evening if you'd like my assistance",
    "Let me know if you'd like some assistance tonight",
    "Let me know if you'd like some assistance in the night",
    "Let me know if you'd like some assistance in the evening",
    "Let me know if you'd like some assistance with dinner",
    "Let me know if you'd like some assistance at dinner",
    "Let me know if you'd like some assistance at night",
    "Let me know if you'd like some assistance during the night",
    "Let me know if you'd like some assistance during the evening",
    "I'm happy to be of assistance anytime tonight",
    "I'm happy to be of assistance anytime in the night",
    "I'm happy to be of assistance anytime in the evening",
    "I'm happy to be of assistance anytime with dinner",
    "I'm happy to be of assistance anytime at dinner",
    "I'm happy to be of assistance anytime at night",
    "I'm happy to be of assistance anytime through the night",
    "I'm happy to be of assistance anytime through the evening",
    "I'm happy to be of assistance anytime during the night",
    "I'm happy to be of assistance anytime during the evening",
    "I'm happy to be of assistance anytime during dinner",
    "I'm happy to help out anytime tonight",
    "I'm happy to help out anytime in the night ",
    "I'm happy to help out anytime in the evening",
    "I'm happy to help out anytime with dinner",
    "I'm happy to help out anytime at dinner",
    "I'm happy to help out anytime at night",
    "I'm happy to help out anytime through the night ",
    "I'm happy to help out anytime through the evening",
    "I'm happy to help out anytime during the night",
    "I'm happy to help out anytime during the evening",
    "I'm happy to help out anytime during dinner",
    "I'm happy to help you anytime tonight ",
    "I'm happy to help you anytime with dinner",
    "I'm happy to help you anytime at dinner",
    "I'm happy to help you anytime at night",
    "I'm happy to help you anytime in the night",
    "I'm happy to help you anytime in the evening",
    "I'm happy to help you anytime during the night",
    "I'm happy to help you anytime during the evening",
    "I'm happy to help you anytime through the night",
    "I'm happy to help you anytime through the evening",
    "I'm happy to help you anytime during dinner",
    "I'm happy to help anytime tonight ",
    "I'm happy to help anytime with dinner",
    "I'm happy to help anytime at dinner",
    "I'm happy to help anytime at night",
    "I'm happy to help anytime in the night",
    "I'm happy to help anytime in the evening",
    "I'm happy to help anytime during the night",
    "I'm happy to help anytime during the evening",
    "I'm happy to help anytime through the night",
    "I'm happy to help anytime through the evening",
    "I'm happy to help anytime during dinner",
    "I hope you're looking forward to tonight",
    "I hope you're looking forward to the evening",
    "I hope you're looking forward to dinner",
    "I hope you're looking forward to dinner today",
    "I hope you're looking forward to the rest of tonight",
    "I hope you're looking forward to the rest of the evening",
    'Enjoy your meal tonight',
    'Enjoy your meal this evening',
    'Enjoy your meal at dinner',
    'Enjoy your meal at dinner time ',
    'Enjoy your evening meal',
    'Enjoy all of your plans for tonight',
    'Enjoy all of your plans for the evening',
    'Enjoy your plans for tonight',
    'Enjoy your plans for the evening',
    'Enjoy your plans for dinner',
    'Enjoy your plans for the rest of tonight',
    'Enjoy your pans for the rest of the evening',
    "Enjoy everything you've planned tonight",
    "Enjoy everything you've planned for tonight",
    "Enjoy everything you've planned for this evening ",
    "Enjoy everything you've planned for the evening",
    "Enjoy everything you've planned for after dinner",
    "Enjoy everything you've planned after dinner",
    'Enjoy tonight to the max',
    'Enjoy the evening to the max',
    'Enjoy dinner to the max',
    'Enjoy your night to the max',
    'Enjoy your evening to the max',
    'Enjoy your dinner to the max',
    'Enjoy your evening activities',
    'Enjoy your evening plans',
    "Enjoy the evening plans you've made",
    "Enjoy those evening plans you've made",
    'Enjoy tonight',
    'Enjoy your evening',
    'Enjoy your dinner',
    'Enjoy the rest of tonight',
    'Enjoy the rest of your evening',
    'I hope you enjoy tonight',
    'I hope you enjoy your evening',
    'I hope you enjoy your dinner',
    'I hope you enjoy the rest of tonight',
    'I hope you enjoy the rest of your evening',
    "I'm hoping you'll enjoy tonight",
    "I'm hoping you'll enjoy the rest of tonight",
    "I'm hoping you'll enjoy your evening",
    "I'm hoping you'll enjoy your dinner",
    "I'm hoping you'll enjoy the rest of your evening",
    'Hopefully you enjoy tonight',
    'Hopefully you enjoy your evening',
    'Hopefully you enjoy your dinner',
    'Hopefully you enjoy the rest of tonight',
    'Hopefully you enjoy the rest of your evening',
    'Hopefully your evening is enjoyable',
    'Hopefully your dinner is enjoyable',
    'Hopefully the rest of your night is enjoyable',
    'Hopefully the rest of your evening is enjoyable',
    "I'm your Monday evening cheer squad",
    "I'm your Tuesday evening cheer squad",
    "I'm your Wednesday evening cheer squad",
    "I'm your Thursday evening cheer squad",
    "I'm your Friday evening cheer squad",
    "I'm your Saturday evening cheer squad",
    "I'm your Sunday evening cheer squad",
    "I'm your Monday night cheer squad",
    "I'm your Tuesday night cheer squad",
    "I'm your Wednesday night cheer squad",
    "I'm your Thursday night cheer squad",
    "I'm your Friday night cheer squad",
    "I'm your Saturday night cheer squad",
    "I'm your Sunday night cheer squad",
    "I'm cheering you on tonight",
    "I'm cheering you on this evening",
    "I'm cheering you on in the evenings",
    "I'm cheering you on in the evening today",
    "I'm cheering you on in the evenings everyday",
    "I hope you know that I'm cheering you on tonight",
    "I hope you know that I'm cheering you on this evening",
    "I hope you know that I'm cheering you on in the evenings",
    "I hope you know that I'm cheering you on this evening ",
    "I hope you know that I'm cheering you on in the evenings everyday",
    "Letting you know that I'm cheering you on tonight",
    "Letting you know that I'm cheering you on this evening",
    "Letting you know that I'm cheering you on in the evenings",
    "Letting you know that I'm cheering you on this evening ",
    "Letting you know that I'm cheering you on in the evenings everyday",
    "I'll be cheering you on tonight",
    "I'll be cheering you on this evening",
    "I'll be cheering you on in the evenings",
    "I'll be cheering you on in the evening today",
    "I'll be cheering you on in the evenings everyday",
    "I hope you know that I'll be cheering you on tonight",
    "I hope you know that I'll be cheering you on this evening",
    "I hope you know that I'll be cheering you on in the evenings",
    "I hope you know that I'll be cheering you on this evening ",
    "I hope you know that I'll be cheering you on in the evenings everyday",
    "I hope you know that I'll be cheering you on every evening",
    "Letting you know that I'll be cheering you on tonight",
    "Letting you know that I'll be cheering you on this evening",
    "Letting you know that I'll be cheering you on in the evenings",
    "Letting you know that I'll be cheering you on this evening ",
    "Letting you know that I'll be cheering you on in the evenings everyday",
    "Letting you know that I'll be cheering you on every evening",
    'So good to see you tonight',
    'So good to see you this evening',
    'So good to see you at dinner',
    'So good to see you at night',
    'So good to see you every night',
    'So good to see you every evening',
    'So good to see you every dinner',
    'So good to see you through the evening',
    "It's so lovely to see you tonight",
    "It's so lovely to see you this evening",
    "It's so lovely to see you at dinner",
    "It's so lovely to see you at night",
    "It's so lovely to see you every night",
    "It's so lovely to see you every evening",
    "It's so lovely to see you every dinner",
    "It's so lovely to see you throughout the evening",
    "I'm so happy to be your assistant tonight",
    "I'm so happy to be your assistant this evening",
    "I'm so happy to be your assistant at dinner",
    "I'm so happy to be your assistant at night",
    "I'm so happy to be your assistant every night",
    "I'm so happy to be your assistant every evening",
    "I'm so happy to be your assistant every dinner",
    "I'm so happy to be your assistant during the evening",
    "I'm so happy to be your assistant during dinner",
    "I'm so happy to be your assistant throughout the evening",
    "I'm honoured to have your company tonight",
    "I'm honoured to have your company this evening",
    "I'm honoured to have your company at dinner time",
    "I'm honoured to have your company every night",
    "I'm honoured to have your company every evening",
    "I'm honoured to have your company every dinner",
    "I'm honoured to have your company during the evening",
    "I'm honoured to have your company during dinner",
    "I just wanted to say it's so good to see you this evening",
    'I just wanted to say how good it is to see you this evening',
    'Have a good night',
    'Have a good evening',
    'Have a relaxing night',
    'Have a relaxing evening',
    'Have a relaxed night',
    'Have a relaxed evening',
    'Have a happy night',
    'Have a happy evening',
    'Have a productive evening',
    'Good evening',
    'Enjoy tonight',
    'Enjoy the evening',
    'Enjoy dinner',
    'Enjoy the rest of tonight',
    'Enjoy the rest of the evening',
  ],
};
